import { create } from "zustand";
import axios, { API_APP_URL } from "../_lib/Axios";

type ClientState = {
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  getProfile: (uid?: string) => Promise<ResponseProps>;
  getCaesRg01: (uid?: string) => Promise<ResponseProps>;
  getCaseByClientId: (uid?: string) => Promise<ResponseProps>;
  dayOptions: OptionProps[];
  monthOptions: OptionMultiLanguageProps[];
};

export const useClientState = create<ClientState>((set: any, get: any) => ({
  isLoading: false,
  setIsLoading: (isLoading) => {
    set({ isLoading: isLoading });
  },
  getProfile: async (uid) => {
    var resultForm: ResponseProps = {};

    const url = `${API_APP_URL}/api/TransClient/${uid}`;
    await axios
      .get(url)
      .then((res: ResponseProps) => {
        resultForm = res;
      })
      .catch((error: any) => {
        resultForm = error;
      });
    return resultForm;
  },
  getCaesRg01: async (uid) => {
    var resultForm: ResponseProps = {};

    const url = `${API_APP_URL}/api/TransCase/validateRG01/${uid}`;
    await axios
      .get(url)
      .then((res: ResponseProps) => {
        resultForm = res;
      })
      .catch((error: any) => {
        resultForm = error;
      });
    return resultForm;
  },
  getCaseByClientId: async (uid) => {
    var resultForm: ResponseProps = {};

    const url = `${API_APP_URL}/api/TransCase/clientId/${uid}`;
    await axios
      .get(url)
      .then((res: ResponseProps) => {
        resultForm = res;
      })
      .catch((error: any) => {
        resultForm = error;
      });
    return resultForm;
  },
  dayOptions: [
    { value: "01", label: "01" },
    { value: "02", label: "02" },
    { value: "03", label: "03" },
    { value: "04", label: "04" },
    { value: "05", label: "05" },
    { value: "06", label: "06" },
    { value: "07", label: "07" },
    { value: "08", label: "08" },
    { value: "09", label: "09" },
    { value: "10", label: "10" },
    { value: "11", label: "11" },
    { value: "12", label: "12" },
    { value: "13", label: "13" },
    { value: "14", label: "14" },
    { value: "15", label: "15" },
    { value: "16", label: "16" },
    { value: "17", label: "17" },
    { value: "18", label: "18" },
    { value: "19", label: "19" },
    { value: "20", label: "20" },
    { value: "21", label: "21" },
    { value: "22", label: "22" },
    { value: "23", label: "23" },
    { value: "24", label: "24" },
    { value: "25", label: "25" },
    { value: "26", label: "26" },
    { value: "27", label: "27" },
    { value: "28", label: "28" },
    { value: "29", label: "29" },
    { value: "30", label: "30" },
    { value: "31", label: "31" },
  ] as OptionProps[],
  monthOptions: [
    { value: "01", labelTh: "มกราคม", labelEn: "January" },
    { value: "02", labelTh: "กุมภาพันธ์", labelEn: "February" },
    { value: "03", labelTh: "มีนาคม", labelEn: "March" },
    { value: "04", labelTh: "เมษายน", labelEn: "April" },
    { value: "05", labelTh: "พฤษภาคม", labelEn: "May" },
    { value: "06", labelTh: "มิถุนายน", labelEn: "June" },
    { value: "07", labelTh: "กรกฏาคม", labelEn: "July" },
    { value: "08", labelTh: "สิงหาคม", labelEn: "August" },
    { value: "09", labelTh: "กันยายน", labelEn: "September" },
    { value: "10", labelTh: "ตุลาคม", labelEn: "October" },
    { value: "11", labelTh: "พฤศจิกายน", labelEn: "November" },
    { value: "12", labelTh: "ธันวาคม", labelEn: "December" },
  ] as OptionMultiLanguageProps[],
}));
